import { render, staticRenderFns } from "./sport.vue?vue&type=template&id=798ae9c0&scoped=true"
import script from "./sport.vue?vue&type=script&lang=js"
export * from "./sport.vue?vue&type=script&lang=js"
import style0 from "./sport.vue?vue&type=style&index=0&id=798ae9c0&prod&lang=css"
import style1 from "./sport.vue?vue&type=style&index=1&id=798ae9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798ae9c0",
  null
  
)

export default component.exports